module.exports = __webpack_public_path__ + "img/asptmr-1.5d9ef452.png";